module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/delete-asset-list/delete-asset-list.component.scss
// module id = ./src/app/delete-asset-list/delete-asset-list.component.scss
// module chunks = main